import { checkout } from '..';

export const voidCheckouts = (applicationUuid: string) =>
  checkout.put('/v1/orchestration/checkouts/void', undefined, { params: { applicationUuid } });

export default voidCheckouts;
